import { useGetVolumes } from "~/api/folders/folders";
import {
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Select } from "~/components/ui/select";
import { ROUTES, useProjectParams } from "~/helpers";
import { useParentCase } from "../../hooks/useParentCase.ts";
import { VolumeActions } from "./VolumeActions";

type VersionOption = {
  id: string;
  label: string;
};

type VersionPanelProps = {
  disableClone?: boolean;
};

export const VersionPanel = ({ disableClone }: VersionPanelProps) => {
  const { organizationId, caseId } = useProjectParams();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { data: versions } = useGetVolumes(organizationId, caseId);
  const { isMaster } = useParentCase();

  const versionOptions =
    versions?.reduce((acc, version) => {
      acc.push(
        version.parentId === null
          ? { id: version.id, label: "Master" }
          : { id: version.id, label: version.name }
      );
      return acc;
    }, [] as VersionOption[]) || [];

  const handleSelectVersion = (versionId: string) => {
    navigate(ROUTES.CASE({ organizationId, caseId: versionId }));
  };

  const oneVersion = versionOptions.length === 1;

  return (
    <div className="flex items-center gap-2 my-[16px]">
      <Select
        value={caseId}
        onValueChange={handleSelectVersion}
        disabled={oneVersion}
      >
        <SelectTrigger className="w-[450px]">
          <SelectValue
            placeholder={formatMessage({
              id: "selectVersionPlaceholder",
              defaultMessage: "Select a version",
            })}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {versionOptions.map((option) => (
              <React.Fragment key={option.id}>
                <SelectItem value={option.id}>{option.label}</SelectItem>
                {option.label === "Master" && !oneVersion && (
                  <SelectSeparator />
                )}
              </React.Fragment>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <VolumeActions isMaster={isMaster} disableClone={disableClone} />
    </div>
  );
};
